import { url } from "inspector";
import { Button } from "react-bootstrap";
import { Facebook, Twitter, Instagram, LinkedIn } from './icons';

export default function Footer() {


    return (
        <>
            <div className='w-100 p-2 mt-4  bg-purple shadow-sm d-flex justify-content-between align-items-center  footer'>
                <div >
                    © All rights reserved. NotchHR {new Date().getFullYear()}
                </div>
                <div className="d-flex justify-content-between p-1 links  ">
                    <span onClick={() => window.open("https://notchhr.io/Privacy-Policy.pdf", '_blank')} className="p-2 clickable">Privacy Policy</span>
                    <span onClick={() => window.open("https://notchhr.io/#", '_blank')} className="p-2 clickable">Terms & Condition</span>

                </div>

                <div className="d-flex">
                    <div onClick={() => window.open("https://www.facebook.com/NotchHR", '_blank')} className="p-1 clickable">
                        <Facebook />
                    </div>
                    <div onClick={() => window.open("https://twitter.com/notchhr", '_blank')} className="p-1 clickable">
                        <Twitter />
                    </div>
                    <div onClick={() => window.open("https://www.instagram.com/notchhr.io/", '_blank')} className="p-1 clickable">
                        <Instagram />
                    </div>
                    <div onClick={() => window.open("https://www.linkedin.com/company/notchhr/", '_blank')} className="p-1 clickable">
                        <LinkedIn />
                    </div>
                </div>

            </div>

        </>
    )
}